// src/components/home2/BannerSlider2.jsx

import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "./newhome.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import HomeService from "../../Services/HomeService";
import HomeService from "../../../Services/HomeService";
import { toast } from "react-toastify";

const Newbanner = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBanners = async () => {
    try {
      setLoading(true);

      const res = await HomeService.getBanner();

      console.log("Banner Response", res);

      if (res?.status) {
        setBanners(res?.data || []);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to load banners");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4500,
    speed: 1200,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
    fade: true,
  };

  return (
    <section className="home2-banner-section">

      {/* LIGHT EFFECTS */}

      <div className="home2-green-light"></div>
      <div className="home2-orange-light"></div>

      {/* LOADER */}

      {loading && (
        <div className="home2-loader-wrapper">

          <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>

        </div>
      )}

      {/* SLIDER */}

      {!loading && (
        <Slider {...settings}>

          {banners?.map((slide, index) => (

            <div key={index}>

              <div className="home2-banner-wrapper">

                {/* BACKGROUND IMAGE */}

                <div className="home2-banner-bg">

                  <img
                    src={slide?.image}
                    alt={slide?.title}
                  />

                </div>

                {/* DARK OVERLAY */}

                <div className="home2-banner-overlay"></div>

                {/* CONTENT */}

                <div className="home2-banner-content">

                  <span className="home2-featured-tag">
                    Featured
                  </span>

                  <h1>
                    {slide?.title}
                  </h1>

                  <p>
                    {slide?.description}
                  </p>
{/* 
                  <div className="home2-banner-btns">

                    <button className="home2-browse-btn">
                      Browse Properties
                    </button>

                    <button className="home2-invest-btn">
                      Invest Now
                    </button>

                  </div> */}

                </div>

              </div>

            </div>

          ))}

        </Slider>
      )}

    </section>
  );
};

export default Newbanner;